import { useState, useEffect, useCallback } from 'react';
import { useUserInfo } from '@/app/stores/useUserStore';
import { INVITE_MODAL_CACHE_KEY, INVITE_MODAL_CACHE_DURATION } from '@/app/const/locale';

export const useInviteModal = (options?: { disabled?: boolean }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isManualOpen, setIsManualOpen] = useState(false);
  const userInfo = useUserInfo();
  const disabled = options?.disabled ?? false;

  // 检查是否应该显示弹窗
  const shouldShowModal = useCallback(() => {
    const closedTime = localStorage.getItem(INVITE_MODAL_CACHE_KEY + userInfo?.userId);
    if (!closedTime) {
      return true; // 首次访问，显示弹窗
    }

    const now = Date.now();
    const lastClosedTime = parseInt(closedTime, 10);
    const timeDiff = now - lastClosedTime;
    // 超过24小时，显示弹窗
    return timeDiff >= INVITE_MODAL_CACHE_DURATION;
  }, []);

  // 关闭弹窗并记录时间
  const closeModal = useCallback(() => {
    setIsOpen(false);
    setIsManualOpen(false);
    localStorage.setItem(INVITE_MODAL_CACHE_KEY + userInfo?.userId, Date.now().toString());
  }, []);

  // 手动打开弹窗
  const openModal = useCallback(() => {
    setIsManualOpen(true);
    setIsOpen(true);
  }, []);

  // 页面加载时检查是否应该显示弹窗
  useEffect(() => {
    // 被禁用时不自动弹出（奖励计划弹窗优先）
    if (disabled) return;
    // 是否邀请人
    const hasPointsUser = !!userInfo?.remainingInviteCount
    // 如果没有邀请人，则不显示弹窗
    const hasInviter = !!userInfo?.inviter
    if (shouldShowModal() && hasPointsUser && hasInviter) {
      // 延迟一点时间显示，确保页面完全加载
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [userInfo, shouldShowModal, disabled]);

  // 监听手动打开
  useEffect(() => {
    if (isManualOpen) {
      setIsOpen(true);
    }
  }, [isManualOpen]);

  return {
    isOpen,
    openModal,
    closeModal,
    isManualOpen,
  };
};
